import { ProductOrBrand } from "./alternativeTypes";

export const drinksProducts: ProductOrBrand[] = [
  {
    name: "Coca-Cola",
    ownerCountry: "US",
    categories: ["drinks", "caffeinated"],
  },
  {
    name: "Pepsi",
    ownerCountry: "US",
    categories: ["drinks", "caffeinated"],
  },
  {
    name: "Fanta",
    ownerCountry: "US",
    categories: ["drinks", "soda"],
  },
  {
    name: "Monster",
    ownerCountry: "US",
    categories: ["drinks", "energy-drinks"],
  },
  {
    name: "Solo",
    ownerCountry: "NO",
    availableIn: ["NO"],
    categories: ["drinks", "soda"],
  },
  {
    name: "Grans",
    ownerCountry: "NO",
    availableIn: ["NO"],
    categories: ["drinks", "caffeinated"],
  },
  {
    name: "Zingo",
    ownerCountry: "DK",
    availableIn: ["SE"],
    categories: ["drinks", "soda"],
  },
  {
    name: "ICA Cola",
    ownerCountry: "SE",
    availableIn: ["SE"],
    categories: ["drinks", "caffeinated"],
  },
  {
    name: "Oshee",
    ownerCountry: "PL",
    headquarterIn: "PL",
    availableIn: ["PL", "DE", "FR", "IT", "ES", "UK"],
    comments: "Polish company specializing in the production of isotonic beverages and energy drinks within the sports nutrition and functional drink industry.",
    categories: ["drinks", "energy-drinks"],
    sourceLinks: ["https://www.cbinsights.com/company/oshee"]
  },
  {
    name: "Green Cola",
    ownerCountry: "GR",
    headquarterIn: "GR",
    availableIn: ["GR", "EE", "DE", "UK", "ES", "LV", "LT", "MT", "RO", "SI", "PL"],
    comments: "Greek brand of cola developed by Green Cola Hellas, known for using natural ingredients like stevia as a sweetener.",
    categories: ["drinks", "caffeinated"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Green_Cola"]
  },
  {
    name: "Eneryeti",
    ownerCountry: "ES",
    headquarterIn: "ES",
    availableIn: ["ES"],
    comments: "Spanish energy drink brand offering a wide variety of unique flavors. Eneryeti Company, established in 2013, specializes in developing and selling soft drinks, including energy drinks, sports drinks, and soft drinks. In November 2023, Eneryeti partnered with the Spanish National Football Team, becoming 'The Energy of the National Team' until 2026.",
    categories: ["drinks", "energy-drinks"],
    sourceLinks: ["https://eneryeti.es/", "https://rfef.es/en/noticias/eneryeti-joins-the-spanish-national-football-team-with-a-partnership-agreement-until-2026"]
},
  {
    name: "Cedevita",
    ownerCountry: "HR",
    availableIn: ["HR", "BA", "MT", "SI"],
    categories: ["drinks", "energy-drinks"],
    sourceLinks: ["https://www.cedevita.com/en/"]
  },  
  {
    name: "Kofola",
    ownerCountry: "CZ",
    availableIn: ["CZ"],
    categories: ["drinks", "caffeinated"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Kofola"]
  },
  {
    name: "Club-Mate",
    ownerCountry: "DE",
    availableIn: ["DE"],
    categories: ["drinks", "caffeinated"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Club-Mate"]
  },
  {
    name: "Cuba Cola",
    ownerCountry: "SE",
    availableIn: ["SE"],
    categories: ["drinks", "caffeinated"],
  },
  {
    name: "Fritz",
    ownerCountry: "DE",
    availableIn: ["DE", "NL", "PL", "BE", "AT", "CA"],
    categories: ["drinks", "caffeinated", "soda"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Fritz-kola"]
  },
  {
    name: "Faxe Kondi",
    ownerCountry: "DK",
    availableIn: ["DK", "NO", "IS"],
    categories: ["drinks", "soda"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Faxe_Kondi"]
  },
  { 
    name: "Jumbo Cola", 
    ownerCountry: "NL", 
    headquarterIn: "NL", 
    availableIn: ["NL"], 
    comments: "Jumbo Cola is a private-label soft drink produced by Jumbo, a Dutch supermarket chain. The cola is available in various flavors, including regular, cherry, and zero-sugar options.", 
    categories: ["drinks", "caffeinated"], 
    sourceLinks: ["https://world.openfoodfacts.org/product/8718452467006/cola-regular-jumbo", "https://www.colatest.com/english/reports/jumbo-cola-cherry.htm"] 
  },
  { 
    name: "AH Cola", 
    ownerCountry: "NL", 
    headquarterIn: "NL", 
    availableIn: ["NL"], 
    comments: "AH Cola is a private-label soft drink sold by Albert Heijn, a Dutch supermarket chain. It is available in different varieties, including regular, light, and zero-sugar versions.", 
    categories: ["drinks", "caffeinated"], 
    sourceLinks: ["https://www.ah.nl/producten/product/wi160605/ah-cola"] 
  },
  { 
    name: "River Cola", 
    ownerCountry: "DE", 
    headquarterIn: "DE", 
    availableIn: ["DE"], 
    comments: "River Cola is a private-label soft drink sold by ALDI Nord, a German discount supermarket chain. It offers various cola variants, including light, zero sugar, and flavored options like vanilla and cherry.", 
    categories: ["drinks", "caffeinated"], 
    sourceLinks: ["https://de.wikipedia.org/wiki/Liste_von_Cola-Marken", "https://www.colatest.com/english/reports/river-cola.htm"] 
  },
    { 
    name: "Freeway", 
    ownerCountry: "DE", 
    headquarterIn: "DE", 
    availableIn: ["DE", "AT", "CH", "NL", "BE", "FR", "DK", "SE", "FI", "PL", "CZ", "RO", "BG", "HR", "SI", "ES", "PT", "IT", "GR", "IE", "UK"], 
    comments: "Freeway is a private-label brand of soft drinks sold by Lidl, a German global discount supermarket chain. The brand offers a variety of beverages, including cola, lemon-lime, and orange-flavored sodas.", 
    categories: ["drinks", "caffeinated", "soda"], 
    sourceLinks: ["https://www.45spaces.com/soda-labels-pop-and-soft-drinks/r.php?r=619-2202582", "https://world.openfoodfacts.org/product/42194422/cola-zero-sugar-freeway"] 
  },
  {
    name: "Pop Cola",
    ownerCountry: "RO",
    availableIn: ["RO"],
    categories: ["drinks", "caffeinated"],
    sourceLinks: ["https://www.reddit.com/r/BuyFromEU/comments/1iwfueb/caffeine_fix_romanian_cola/"]
  },
  {
    name: "Breizh Cola",
    ownerCountry: "FR",
    availableIn: ["FR"],
    categories: ["drinks", "caffeinated"],
    sourceLinks: ["https://fr.wikipedia.org/wiki/Breizh_Cola"]
  },  
  {
    name: "Jolly",
    ownerCountry: "FI", // Olvi
    headquarterIn: "DK",
    availableIn: ["DK", "FR"],
    categories: ["drinks", "caffeinated"],
    sourceLinks: ["https://bryggeriet-vestfyen.dk/jolly-cola/#omjolly"]
  },  
  {
    name: "Irn-Bru",
    ownerCountry: "UK",
    availableIn: ["UK", "NL", "ES", "BE", "IE"],
    categories: ["drinks", "soda"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Irn-Bru"]
  },  
  {
    name: "Jolly's",
    ownerCountry: "UK", // Olvi
    availableIn: ["UK"],
    categories: ["drinks", "soda"],
    sourceLinks: ["https://jollysdrinks.co.uk"]
  },  
  {
    name: "Cidona",
    ownerCountry: "DK", 
    headquarterIn: "UK",
    availableIn: ["IE","UK"],
    categories: ["drinks", "soda"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Cidona"]
  },
  {
    name: "Jaffa",
    ownerCountry: "DK", 
    headquarterIn: "FI",
    availableIn: ["FI","CH"],
    categories: ["drinks", "soda"],
    sourceLinks: ["https://sv.wikipedia.org/wiki/Jaffa_(läskedryck)"]
  },
  {
    name: "Olvi",
    ownerCountry: "FI",
    availableIn: ["FI"],
    categories: ["drinks", "caffeinated", "soda"],
    sourceLinks: ["https://sv.wikipedia.org/wiki/Jaffa_(läskedryck)"]
  },
  {
    name: "Novelle",
    ownerCountry: "DK",  // Hartwall -> Royal Unibrew
    headquarterIn: "FI",
    availableIn: ["FI"],
    categories: ["drinks", "soda"],
    sourceLinks: ["https://fi.wikipedia.org/wiki/Novelle"]
  },  
  {
    name: "Zyla",
    ownerCountry: "BE",
    availableIn: ["BE"],
    categories: ["drinks", "soda"],
    sourceLinks: ["https://zyladrink.com/policies/contact-information"]
  },
  {
    name: "етър",
    ownerCountry: "BG",
    availableIn: ["BG"],
    categories: ["drinks", "soda"],
    sourceLinks: ["https://www.kashkaval-tourist.com/10-bulgarian-drinks-must-try/"]
  },
  {
    name: "ДЕРБИ",
    ownerCountry: "BG",
    availableIn: ["BG"],
    categories: ["drinks", "caffeinated", "soda"],
    sourceLinks: ["https://as-mega.com/index.php?route=product/category&path=66#google_vignette"]
  },
  {
    name: "Florina",
    ownerCountry: "GR",
    availableIn: ["BG","GR"],
    categories: ["drinks", "soda"],
    sourceLinks: ["https://florina.bg/en/816-2/"]
  },
  {
    name: "BBB",
    ownerCountry: "AM",
    availableIn: ["BG"],
    comments: "Made by Bulgarian BC - Gorna Banya Ltd owned by Armenian Multi Group Concern",
    categories: ["drinks", "soda"],
    sourceLinks: [
      "https://gornabania.com/en/about-us",
      "http://www.multigroup.am/en/home.html"
    ]
  },
  {
    name: "Vitamin Well",
    ownerCountry: "SE",
    availableIn: ["NO", "SE", "DK", "FI", "DE", "NL", "FR", "ES", "IE"],
    categories: ["drinks", "energy-drinks"],
    sourceLinks: ["https://www.allabolag.se/foretag/vitamin-well-ab/stockholm/livsmedel/2K2GHFDI5YFWD"]
  },
  {
    name: "Red Bull",
    include: false, // Allegedly has a CEO that's a Trump supporter and sponsor of far right parties
    ownerCountry: "AT",
    categories: ["drinks", "energy-drinks"],
    sourceLinks: ["https://www.thefader.com/2017/04/24/red-bull-ceo-launching-right-wing-news-breitbart-trump"]
  },
  {
    name: "Sumol",
    ownerCountry: "PT",
    headquarterIn: "PT",
    availableIn: ["PT", "ES", "FR", "UK", "LU" ],
    comments: "Portuguese brand of fruit-based carbonated soft drinks, known for flavors like orange, pineapple, and passion fruit. Established in 1954, Sumol is produced by Sumol + Compal and sold in over 60 countries.",
    categories: ["drinks", "soda"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Sumol_%2B_Compal", "https://sumolcompal.pt/en"]
  },
  {
    name: "Brisa",
    ownerCountry: "PT",
    headquarterIn: "PT",
    availableIn: ["PT", "BE", "NL", "LU"],
    comments: "A range of soft drinks produced by Empresa de Cervejas da Madeira, popular in Madeira, Portugal, with flavors like passion fruit, orange, and pineapple.",
    categories: ["drinks", "soda"],
    sourceLinks: ["https://www.ecm.pt/en/portfolio_page/brisa-maracuja/", "https://brisabenelux.com/"]
  },
  {
    name: "Jones",
    ownerCountry: "CA",
    headquarterIn: "US",
    include: false, 
    availableIn: ["CA"],
    comments: "Jones Soda is a one of a kind premium soda known for its bold, unique flavors, colors, and ever changing labels submitted by our consumers. Created in Vancouver, BC in 1995",
    categories: ["drinks", "soda"],
    sourceLinks: ["https://www.jonessoda.com/pages/about-us"]
  },
  {
    name: "Cove",
    ownerCountry: "CA",
    availableIn: ["CA"],
    comments: "Cove Soda, the first-ever, zero sugar functional soda made with 1 billion probiotics, and real organic ingredients.",
    categories: ["drinks", "soda"],
    sourceLinks: ["https://www.covesoda.com/find-us/"]
  },
  {
    name: "big8",
    ownerCountry: "CA",
    availableIn: ["CA"],
    comments: "Located in Stellarton, Nova Scotia on Canada’s East Coast, Big 8 Beverages has been providing high-quality water and soft drinks to our customers since 1986.",
    categories: ["drinks", "soda", "caffeinated"],
    sourceLinks: ["https://big8beverages.ca"]
  },
  
];